module.exports = __webpack_public_path__ + "img/angst_320.62da21f0.webp";